import moment from 'moment';

const converTime = time => time.toString().replace(/\D+/g, '');

export const convertDotNetTimeToDate = (dotNetDateTimeString) => {
  if (!dotNetDateTimeString) {
    return moment();
  }

  const date = moment.unix(converTime(dotNetDateTimeString)/1000);

  return moment(date).format("DD/MM/YYYY HH:mm:ss");
};

export const convertDotNetTimeToMomentDate = (dotNetDateTimeString) => {
  if (!dotNetDateTimeString) {
    return moment();
  }

  const date = moment.unix(converTime(dotNetDateTimeString)/1000);

  return moment(date);
};
